import * as React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'common/appState';
import {
    getBenefits,
    getFilteringBenefitsStatus,
} from 'features/benefit/selectors/benefitSelectors';
import { redirectToUrl } from 'common/actions/navigationAction';
import {
    saveFilters,
    autocompleteRequest,
    clearFilters,
    paginationRequest,
} from 'features/pagination/actions/paginationActions';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { getFilterParams } from 'features/pagination/selectors/paginationSelectors';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { RouteParams, getPageNumber } from 'common/selectors/routeSelectors';
import { isAdmin, isTenant } from 'features/user/selectors/userSelectors';
import {
    ArchiveBenefitRequest,
    Benefit,
    BenefitPathParams,
    UnarchiveBenefitRequest,
} from 'features/benefit/models/benefitModels';
import {
    archiveBenefitRequest,
    deleteBenefitRequest,
    toggleMultipleEmployeesRoleRequest,
    toggleMultipleInvitePendingExecutiveUsersRoleRequest,
    unarchiveBenefitRequest,
} from 'features/benefit/actions';

import { EditBenefit as EditBenefitComponent } from '../components/EditBenefit';

export interface EditBenefitStateProps {
    benefits: Benefit[];
    isFiltered: boolean;
    isUserAdmin: boolean;
    isUserTenant: boolean;
    filter?: PaginationFilters;
    pageNumber?: number;
}

interface EditBenefitDispatchProps {
    deleteBenefitRequest: typeof deleteBenefitRequest;
    redirectToUrl: typeof redirectToUrl;
    autocompleteRequest: typeof autocompleteRequest;
    clearFilters: typeof clearFilters;
    saveFilters: typeof saveFilters;
    paginationRequest: typeof paginationRequest;
    toggleMultipleEmployeesRoleRequest: typeof toggleMultipleEmployeesRoleRequest;
    toggleMultipleInvitePendingExecutiveUsersRoleRequest: typeof toggleMultipleInvitePendingExecutiveUsersRoleRequest;
    archiveBenefitRequest: typeof archiveBenefitRequest;
    unarchiveBenefitRequest: typeof unarchiveBenefitRequest;
}

export type EditBenefitProps = EditBenefitDispatchProps & EditBenefitStateProps & RouteParams;

export class EditBenefit extends React.Component<EditBenefitProps> {
    public deleteBenefit = (benefitId: number, contractId: number) => {
        const deleteBenefitData: BenefitPathParams = {
            benefitId,
            contractId,
        };

        this.props.deleteBenefitRequest(deleteBenefitData);
    };
    public archiveBenefit = (id: number, organisationId: number, contractId: number) => {
        const archiveBenefitData: ArchiveBenefitRequest = {
            id,
            organisationId,
            contractId,
        };

        this.props.archiveBenefitRequest(archiveBenefitData);
    };
    public unarchiveBenefit = (id: number, organisationId: number, contractId: number) => {
        const unarchiveBenefitData: UnarchiveBenefitRequest = {
            id,
            organisationId,
            contractId,
        };

        this.props.unarchiveBenefitRequest(unarchiveBenefitData);
    };
    public render(): JSX.Element {
        return (
            <EditBenefitComponent
                deleteBenefit={this.deleteBenefit}
                archiveBenefit={this.archiveBenefit}
                unarchiveBenefit={this.unarchiveBenefit}
                {...this.props}
            />
        );
    }
}

const mapStateToProps = (state: AppState, ownProps: RouteParams) => ({
    benefits: getBenefits(state),
    isFiltered: getFilteringBenefitsStatus(state),
    isUserAdmin: isAdmin(state),
    isUserTenant: isTenant(state),
    filter: getFilterParams(state, PaginationView.Benefits),
    pageNumber: getPageNumber(ownProps),
});

export const EditBenefitContainer = connect(mapStateToProps, {
    deleteBenefitRequest,
    redirectToUrl,
    autocompleteRequest,
    clearFilters,
    saveFilters,
    paginationRequest,
    toggleMultipleEmployeesRoleRequest,
    toggleMultipleInvitePendingExecutiveUsersRoleRequest,
    archiveBenefitRequest,
    unarchiveBenefitRequest,
})(EditBenefit);
